import { useEffect, useRef, useState } from 'react';

/** Measures a container so charts render at real pixel sizes (no viewBox scaling). */
export function useElementWidth<T extends HTMLElement>(fallback = 640) {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(fallback);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) setWidth(Math.max(entry.contentRect.width, 240));
    });
    observer.observe(node);
    setWidth(Math.max(node.clientWidth, 240));
    return () => observer.disconnect();
  }, []);

  return { ref, width };
}
